export default __webpack_public_path__ + "static/media/2526 utensils side.9a047038.png";